<template>
  <div id="trace-farm">
    <div class="view" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
      <div class="check-images" v-show="checkImages" @click="checkMorePictures">查看更多图片</div>
      <img class="farm-show-img" :src="getFarmMessage.picture" />
      <table class="farm-msg">
        <tr>
          <td class="farm-msg-label">农场名称</td>
          <td class="farm-msg-text farm-msg-name">{{ getFarmMessage.name }}</td>
        </tr>
        <tr>
          <td class="farm-msg-label">农场面积</td>
          <td class="farm-msg-text">{{ getFarmMessage.area }}</td>
        </tr>
        <tr>
          <td class="farm-msg-label">联系人</td>
          <td class="farm-msg-text farm-msg-linkman">{{ getFarmMessage.linkman }}</td>
        </tr>
        <tr>
          <td class="farm-msg-label">联系方式</td>
          <td class="farm-msg-text">{{ getFarmMessage.phone }}</td>
        </tr>
        <tr class="farm-msg-address-tr">
          <td class="farm-msg-label">农场地址</td>
          <td class="farm-msg-text farm-msg-address">{{ getFarmMessage.address }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "trace-farm",
  data() {
    return {
      checkImages: false
    };
	},
	computed: {
		...mapGetters("trace", ["getFarmMessage"])
  },
  methods: {
    handleMouseEnter() {
      this.checkImages = true;
    },
    handleMouseLeave() {
      this.checkImages = false;
    },
    // 向/components/trace/trace.vue父组件传递打开图片预览弹窗
    checkMorePictures() {
      this.$emit("check-more-pictures", true);
    }
  }
};
</script>

<style scoped>
#trace-farm {
  position: relative;
  width: 100%;
  height: 100%;
}

.view {
  position: relative;
  width: 100%;
  height: 100%;
}

.check-images {
  position: relative;
  width: 100%;
  height: 16%;
  color: #ffffff;
  background-color: rgba(23, 74, 114, 0.8);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 0.5vw;
  font-size: 0.6vw;
  z-index: 4;
}

.check-images:hover {
  cursor: pointer;
}

.farm-show-img {
  display: block;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: 100%;
  max-height: 100%;
}

.farm-msg {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  border-collapse: collapse;
}

.farm-msg tr {
  width: 50%;
  height: 1.6vw;
  line-height: 1.6vw;
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.2vw;
}

.farm-msg-label {
  position: relative;
  width: 3vw;
  height: 100%;
  font-size: 0.6vw;
  text-align: center;
  background-color: rgba(0, 56, 100, 0.9);
  color: #ffffff;
  margin-right: 0.2vw;
}

.farm-msg-text {
  position: relative;
  width: calc(100% - 3.2vw);
  height: 100%;
  color: #afbabe;
  font-size: 0.6vw;
  background-color: rgba(0, 24, 42, 0.9);
  padding-left: 0.5vw;
  margin-right: 0.2vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.farm-msg-name {
  width: calc(100% - 3.2vw);
}

.farm-msg-linkman {
  width: calc(100% - 3.2vw);
}

.farm-msg-address-tr {
  width: 100% !important;
  margin-bottom: 0 !important;
}

.farm-msg-address {
  width: calc(100% - 3.2vw);
}
</style>
